/**
 * configureDb — DB 풀 주입
 *
 * 앱 시작 시 한 번만 호출한다. mysql2/promise Pool과 호환되는 인터페이스를 받는다.
 * global 에 저장하므로 Next.js 개발 모드 hot reload 에도 풀이 유지된다.
 *
 * @example
 * import pool from "./config/db";
 * import { configureDb } from "@sunkim4638/admin-modules/db";
 * configureDb(pool);
 */

export interface DbConnection {
    query(sql: string, params?: any[]): Promise<[any, any]>;
    beginTransaction(): Promise<void>;
    commit(): Promise<void>;
    rollback(): Promise<void>;
    release(): void;
}

export interface DbPool {
    query(sql: string, params?: any[]): Promise<[any, any]>;
    getConnection(): Promise<DbConnection>;
}

declare global {
    // eslint-disable-next-line no-var
    var __adminModulesDbPool__: DbPool | undefined;
}

export function configureDb(pool: DbPool): void {
    global.__adminModulesDbPool__ = pool;
}

export function getPool(): DbPool {
    if (!global.__adminModulesDbPool__) {
        throw new Error("[db] configureDb()를 먼저 호출해야 합니다.");
    }
    return global.__adminModulesDbPool__;
}
